import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ProductTagsTranslationFragment } from "@saleor/fragments/types/ProductTagsTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsProductTagPageProps
  extends TranslationsEntitiesPageProps {
  tag: ProductTagsTranslationFragment;
}

export const fieldNames = {
  name: "name"
};

const TranslationsProductTagPage: React.FC<TranslationsProductTagPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  tag,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Product Tag "{productName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            productName: maybe(() => tag.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Tag Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              tag.translation ? tag.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => tag.name)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsProductTagPage.displayName = "TranslationsProductTagPage";
export default TranslationsProductTagPage;
